import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/vocalfactorylogo.png';

const Navbar = ({ theme, setTheme }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="nav">
      {/* Brand Logo */}
      <NavLink to="/" className="brand">
        <img src={logo} alt="Vocal Factory Global" />
        <div>
          <div style={{ fontWeight: 700 }}>Vocal Factory Global</div>
          <small style={{ color: 'var(--muted)' }}>
            Voice • Recordings • Production
          </small>
        </div>
      </NavLink>

      {/* Hamburger / Close Button for Mobile */}
      <button
        className="menu-toggle"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        {isOpen ? '✖' : '☰'}
      </button>

      {/* Nav Links */}
      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        <NavLink to="/" className="nav-link" onClick={closeMenu}>
          Home
        </NavLink>
        <NavLink to="/about" className="nav-link" onClick={closeMenu}>
          About
        </NavLink>
        <NavLink to="/our-works" className="nav-link" onClick={closeMenu}>
          Sound Gallery
        </NavLink>
        <NavLink to="/contact" className="nav-link" onClick={closeMenu}>
          Contact
        </NavLink>

        {/* External Blogs Link */}
        <a
          href="https://thevocalfactory.blogspot.com/"
          className="nav-link"
          target="_blank"
          rel="noopener noreferrer"
          onClick={closeMenu}
        >
          Blogs
        </a>

        {/* Theme Toggle Button */}
        <button
          onClick={() => {
            toggleTheme();
            closeMenu();
          }}
          className="nav-link"
          aria-label="Toggle theme"
          style={{ 
            fontWeight: 600, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          {theme === 'dark' ? (
            // Professional Sun Icon
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
          ) : (
            // Professional Moon Icon
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
          )}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;